export const VALIDATION_ERROR_CODES = {
  OBSERVER_ROLE_NOT_ELIGIBLE: 'OBSERVER_ROLE_NOT_ELIGIBLE'
};
